document.addEventListener('scroll', function() {
    var scrolled = window.scrollY;
    var background = document.querySelectorAll('.background-leaves');
    background.forEach(function(element) {
        element.style.backgroundPosition = 'center ' + (scrolled * 0.5) + 'px';
        //element.style.backgroundRepeat = 'no-repeat';
    });
}); 